import React from "react"
import styled, { createGlobalStyle } from "styled-components"
import Quote from "../components/Quote/Quote"
import Picture from "../components/Picture/Picture"

const GlobalStyle = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css?family=Merriweather:400,700|Source+Sans+Pro:400,700');

    :root {
      --mainWhite: #FEFEFE;
      --mainGray: #999;
      --mainBlack: #222;
      --mainPink: orangered;
    }
    *,
    *::before,
    *::after { 
        margin: 0;
        padding: 0;
        box-sizing: inherit;
    }
    html {
        font-size: 62.5%;
        box-sizing: border-box;

        @media (max-width: 992px) {
          font-size: 50%;
        }      
    }
    body {
        height: 100%;
        font-family: 'Source Sans Pro', sans-serif;
        color: var(--mainGray);
        background: #eee;
    }
`

const AppWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 992px;
  height: 600px;
  display: flex;
  border-radius: 10px;
  box-shadow: 3px 3px 2px 1px #444;
  background-color: var(--mainWhite);
  overflow: hidden;

  @media (max-width: 992px) {
    width: 576px;
    height: 312px;
  }

  @media (max-width: 576px) {
    width: 100%;
    height: 100vh;
    border-radius: 0;
  }
`

const Layout = ({ imgData, author, quote }) => (
  <div>
    <GlobalStyle />
    <AppWrapper>
      <Picture imgData={imgData} author={author} quote={quote} />
      <Quote author={author} quote={quote} />
    </AppWrapper>
  </div>
)

export default Layout
